/**
 * Constantes estables del contrato núcleo ↔ módulos.
 * Cambiar cualquiera de estos valores es un cambio mayor de versión.
 */
/** Audiencia de los tokens que consumen el API del núcleo (`/api/v1`) en nombre de un módulo. */
export const PLATFORM_AUDIENCE = "platform";
/** Audiencia de los tokens de operadores Continnua (consola de plataforma). */
export const CONSOLE_AUDIENCE = "platform-console";
/**
 * Código del módulo que representa al propio portal (`app.continnua.com`, `apps/launcher`).
 *
 * No es un módulo de negocio: no se vende, no tiene plan y ninguna organización se suscribe a él.
 * Existe por dos razones (ADR-007). La primera, que todo cliente OAuth pertenece a un módulo
 * (`oauth_clients.module_code`), y el portal necesita el suyo. La segunda, que su rol
 * `PORTAL_ORG_ADMIN_ROLE` permite designar a quien administra una organización sin obligarle a
 * tener un rol de un producto que quizá no usa.
 */
export const PORTAL_MODULE_CODE = "continnua";
/** Rol del módulo del portal que designa a quien administra la organización. */
export const PORTAL_ORG_ADMIN_ROLE = "org_admin";
/** Vida del access token en segundos. */
export const ACCESS_TOKEN_TTL_SECONDS = 15 * 60;
/** Tolerancia de reloj aceptada al verificar `exp`/`iat`, en segundos. */
export const CLOCK_TOLERANCE_SECONDS = 30;
/** Vida máxima de una sesión (y de sus refresh tokens) en días. */
export const SESSION_MAX_DAYS = 30;
/** Días de inactividad tras los cuales una sesión caduca. */
export const SESSION_IDLE_DAYS = 7;
/** Prefijo de los refresh tokens opacos (`crt_` = Continnua refresh token). */
export const REFRESH_TOKEN_PREFIX = "crt_";
export const SCOPES = Object.freeze({
    OPENID: "openid",
    PROFILE: "profile",
    EMAIL: "email",
    OFFLINE_ACCESS: "offline_access",
    ORG_SWITCH: "org:switch",
    PLATFORM_ENTITLEMENTS_READ: "platform:entitlements:read",
    PLATFORM_USAGE_WRITE: "platform:usage:write",
    PLATFORM_ORGS_READ: "platform:orgs:read",
    PLATFORM_MEMBERS_READ: "platform:members:read",
    /**
     * Gestionar miembros de la propia organización desde una interfaz de usuario (ADR-007). Solo se
     * concede a clientes de primera parte pensados para eso —hoy únicamente `launcher-web`—: no
     * autoriza por sí mismo, se suma al rol administrador que el usuario debe tener en la
     * organización. Un módulo nunca lo recibe, ni con token de máquina ni con el token de su usuario.
     */
    PLATFORM_MEMBERS_WRITE: "platform:members:write",
});
export const WEBHOOK_EVENTS = Object.freeze([
    "organization.updated",
    "organization.suspended",
    "organization.reactivated",
    "membership.changed",
    "subscription.changed",
    "user.updated",
]);
/** Cabeceras con que el núcleo firma cada entrega de webhook. */
export const WEBHOOK_HEADERS = Object.freeze({
    SIGNATURE: "x-continnua-signature",
    EVENT: "x-continnua-event",
    DELIVERY: "x-continnua-delivery",
});
/** Expresiones regulares compartidas para identificadores públicos. */
export const PATTERNS = Object.freeze({
    /** Slug de organización: minúsculas, dígitos y guiones, 1–63 caracteres, sin guiones en los extremos. */
    ORG_SLUG: /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/,
    /** Código de módulo: empieza por letra, minúsculas, dígitos y guion bajo, 2–32 caracteres. */
    MODULE_CODE: /^[a-z][a-z0-9_]{1,31}$/,
    /** Claves de rol, feature y límite: snake_case, 2–48 caracteres. */
    KEY: /^[a-z][a-z0-9_]{1,47}$/,
});
//# sourceMappingURL=constants.js.map